import { render, staticRenderFns } from "./CapterraReviewsSection.vue?vue&type=template&id=0e8562d8&scoped=true"
import script from "./CapterraReviewsSection.vue?vue&type=script&lang=js"
export * from "./CapterraReviewsSection.vue?vue&type=script&lang=js"
import style0 from "./CapterraReviewsSection.vue?vue&type=style&index=0&id=0e8562d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8562d8",
  null
  
)

export default component.exports